<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('projects.list') }}</h1>
      <div class="level table-actions">
        <div class="level-left">
          <form @submit.prevent="onSearch">
            <div class="field is-grouped controls">
              <div class="control">
                <b-input v-model="q" :placeholder="$t('interface.search')"></b-input>
              </div>
              <div class="control">
                <button type="submit" class="button is-primary">
                  <b-icon icon="magnify" size="is-small"></b-icon>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="level-right">
          <div class="field is-grouped controls">
            <div class="control">
              <button @click="goTo('createProject')"
                      class="button is-success">
                {{ $t('projects.create') }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <b-table class="mt-10"
               :data="list.results"
               :loading="loading"

               paginated
               backend-pagination
               :total="total"
               :per-page="perPage"
               @page-change="onPageChange"

               backend-sorting
               default-sort-direction="desc"
               :default-sort="[sortField, sortOrder]"
               @sort="onSort">
        <template slot-scope="props">
          <b-table-column :label="$t('projects.title')" field="name" sortable>
            <a @click.prevent="detail(props.row.id)">{{ props.row.name }}</a>
          </b-table-column>
          <b-table-column :label="$t('projects.sourceType')" field="source_type" sortable>
            {{ $t(`projectControl.sourceTypes.${props.row.source_type}`) }}
          </b-table-column>
          <b-table-column :label="$t('projects.projectType')" field="category" sortable>
            {{ props.row.category__name }}
          </b-table-column>
          <b-table-column :label="$t('projects.branch')" field="branch" sortable>
            {{ props.row.branch__name }}
          </b-table-column>
          <b-table-column :label="$t('projects.state')" field="state" sortable>
            {{ $t(`projectControl.states.${props.row.state}`) }}
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content is-fluid has-text-grey has-text-centered">
              <p>{{ $t('interface.nothingFound') }}
                <a class="is-dashed" @click.prevent="resetFilters">{{ $t('interface.resetFiltersAndSearch') }}</a>.
              </p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'

  export default {
    components: {
      DashboardLayout
    },
    data() {
      return {
        total: 0,
        page: 1,
        perPage: 15,
        q: '',
        sortField: '',
        sortOrder: 'desc'
      }
    },
    methods: {
      loadData() {
        this.$store.dispatch('Project/getList', {
          page: this.page,
          page_size: this.perPage,
          q: this.q,
          ordering: `${this.sortOrder === 'desc' ? '-' : ''}${this.sortField}`
        }).then(data => {
          this.total = data.count
        })
      },
      onSort(field, order) {
        this.sortField = field
        this.sortOrder = order
        this.loadData()
      },
      onPageChange(page) {
        this.page = page
        this.loadData()
      },
      onSearch() {
        this.loadData()
      },
      resetFilters() {
        this.q = ''
        this.loadData()
      },
      goTo(route) {
        this.$router.push({name: route})
      },
      detail(id) {
        this.$router.push({
          name: 'projectDetail',
          params: {projectId: id}
        })
      }
    },
    mounted() {
      this.loadData()
    },
    computed: {
      ...mapState('Project', ['loading', 'list']),
      breadcrumbs() {
        return [
          {name: 'projects'}
        ]
      }
    }
  }
</script>
